<template>
    <DsDropdown
        data-qa="header-sequence-actions-menu"
        disable-scroll
        :is-open="isOpen"
        position="bottom-end"
        @close="close"
    >
        <template #default>
            <DsIconButton
                data-qa="ellipsis-menu"
                name="more-vertical"
                @click="toggle"
            />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    data-qa="rename-sequence-button"
                    class="dropdown-menu-item"
                    @click="renameSequence"
                >
                    <div>
                        {{ $t('funnel.edit.sequence.rename') }}
                    </div>
                </li>

                <li data-qa="copy-from-campaign-button" class="dropdown-menu-item" @click="copyFromCampaign">
                    <div>
                        {{ $t('funnel.edit.sequence.copyFromCampaign') }}
                    </div>
                </li>

                <hr />
                <li
                    data-qa="toggle-sequence-button"
                    class="dropdown-menu-item no-hover"
                    @click="toggleSequenceReady"
                >
                    <DsToggleSwitch
                        :value="sequenceIsReady"
                        :label-on="$t('funnel.header.readyToggle.ready')"
                        :label-off="$t('funnel.header.readyToggle.draft')"
                        class="sequence-toggle"
                        @input="toggleSequenceReady"
                    />
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
export default {
    props: {
        sequenceIsReady: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle-sequence-ready', 'copy-from-campaign', 'sequence-rename'],
    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        toggleSequenceReady() {
            this.$emit('toggle-sequence-ready');
        },
        copyFromCampaign() {
            this.$emit('copy-from-campaign');
            this.close();
        },
        renameSequence() {
            this.$emit('sequence-rename');
            this.close();
        },
        toggle() {
            this.isOpen = !this.isOpen;
        },
        close() {
            this.isOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
hr {
    margin: 0;
    border-color: $color-gray-200;
}
.sequence-toggle {
    font-weight: normal;
    font-size: $font-size-md;
}
</style>
